import { ContentType } from '@smart-tv/typings/content';

const isVodContent = (contentType: ContentType) => {
  const vodContentTypes = [ContentType.Movies, ContentType.Series, ContentType.Program];
  return vodContentTypes.includes(contentType);
};

export { isVodContent };
